<template>
  <div class="single-function closeTop">
    <a href="#" @click.prevent="close" id="single-function-btn-close" class="single-function__close"><span class="screen-reader-text">Close</span>ESC</a>
    <fade-transition :duration="{leave: 1000}">
      <loading v-if="loading" :size="'md'"></loading>
    </fade-transition>
    <div class="single-function-content-wrapper">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  mixins: [],
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({}),
  mounted () {
    document.body.addEventListener('keyup', this.close)
  },
  destroyed () {
    document.removeEventListener('keyup', this.close)
  },
  watch: {},
  computed: {},
  methods: {
    close (e) {
      if (e.type === 'click' || (e.type === 'keyup' && e.keyCode === 27)) this.$emit('close')
    }
  },
  directives: {},
  filters: {},
  i18n: { messages: {} }
}
</script>

<style scoped lang='scss'>
@import '../../../assets/scss/shipbob-custom/components/singleFunction/_layout.scss';
</style>
